import { render } from "./shareD.vue?vue&type=template&id=a3feca68"
import script from "./shareD.vue?vue&type=script&lang=js"
export * from "./shareD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__